import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {Area, CityDataInfo, CityDataSource, CityIndicatorScore, IndicatorSearchFilter} from 'app/shared/objects/cities';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormIndicatorsService} from 'app/public/form-indicators/form-indicators.service';
import {
	IndicatorsSingleDataModalComponent
} from '../modal/indicators-single-data-modal/indicators-single-data-modal.component';
import {CityProfileService} from 'app/restricted/city-profile/service/city-profile.service';
import {InternationalizationService} from 'app/shared/services/internationalization.service';
import {
	IndicatorsMultipleDataModalComponent
} from '../modal/indicators-multiple-data-modal/indicators-multiple-data-modal.component';
import {ConfigurationService} from 'app/shared/services/configuration.service';
import {IndicatorSearchParams} from 'app/shared/objects/indicator';
import {ListServices} from 'app/shared/objects/main';
import {SanitizeChar} from 'app/shared/util/sanitize-char';


@Component({
	selector: 'app-indicators-data-year-editor',
	templateUrl: './indicators-data-year-editor.component.html',
	styleUrls: [
		'./painel-legado.scss',
		'./indicators-data-year-editor.component.scss'
	]
})
export class IndicatorsDataYearEditorComponent implements OnInit {
	public labelColumns = {};
	public labelColumnKeys = [];
	public filters: Array<any> = [];
	public countFilter: number;
	public params: IndicatorSearchParams = new IndicatorSearchParams();
	public results: ListServices = new ListServices;
	public loading;
	public openFilter: boolean;
	public areas: Area[] = [];
	public dataSources: CityDataSource[] = [];
	public indicators: CityIndicatorHistoryHelper = new CityIndicatorHistoryHelper;
	public indicatorFilter: IndicatorSearchFilter = new IndicatorSearchFilter;
	@Input() cityId: string = null;
	@Input() area: string = null;
	@Input() showFilter: boolean = false;
	@Input() cityProfile: boolean = false;
	@Input() canEdit?: boolean = false;
	private UNEXPECTED_ERROR: string = "Unexpected error. Try again later.";
	private INDICATOR_CREATED_SUCCESS: string;
	private INDICATOR_CREATED_FALSE: string;
	private INDICATOR_UPDATED_SUCCESS: string;
	private INDICATOR_UPDATED_FALSE: string;
	private DATA_DELETED_SUCCESS: string;
	private DATA_DELETED_FALSE: string;
	private YEAR_UPDATED_SUCCESS: string;
	private YEAR_UPDATED_FALSE: string;
	private YEAR_CREATED_SUCCESS: string;
	private YEAR_CREATED_FALSE: string;
	private _dialogRef: any;

	constructor(
		private dialog: MatDialog,
		private snackBar: MatSnackBar,
		private service: CityProfileService,
		private openService: FormIndicatorsService,
		private internationalizationService: InternationalizationService,
		private config: ConfigurationService,
		private sanitizeChar: SanitizeChar
	) {
	}

	ngOnInit() {

		this.internationalizationService.translate.get("configuration/unexpected-error").subscribe((text: string) => {
			this.UNEXPECTED_ERROR = text;
		});
		this.internationalizationService.translate.get("painel-dashboard/indicator-created-success").subscribe((text: string) => {
			this.INDICATOR_CREATED_SUCCESS = text;
		});
		this.internationalizationService.translate.get("painel-dashboard/indicator-created-false").subscribe((text: string) => {
			this.INDICATOR_CREATED_FALSE = text;
		});
		this.internationalizationService.translate.get("painel-dashboard/indicator-updated-success").subscribe((text: string) => {
			this.INDICATOR_UPDATED_SUCCESS = text;
		});
		this.internationalizationService.translate.get("painel-dashboard/indicator-updated-false").subscribe((text: string) => {
			this.INDICATOR_UPDATED_FALSE = text;
		});
		this.internationalizationService.translate.get("painel-dashboard/data-deleted-success").subscribe((text: string) => {
			this.DATA_DELETED_SUCCESS = text;
		});
		this.internationalizationService.translate.get("painel-dashboard/data-deleted-false").subscribe((text: string) => {
			this.DATA_DELETED_FALSE = text;
		});
		this.internationalizationService.translate.get("painel-dashboard/year-updated-success").subscribe((text: string) => {
			this.YEAR_UPDATED_SUCCESS = text;
		});
		this.internationalizationService.translate.get("painel-dashboard/year-updated-false").subscribe((text: string) => {
			this.YEAR_UPDATED_FALSE = text;
		});
		this.internationalizationService.translate.get("painel-dashboard/year-created-success").subscribe((text: string) => {
			this.YEAR_CREATED_SUCCESS = text;
		});
		this.internationalizationService.translate.get("painel-dashboard/year-created-false").subscribe((text: string) => {
			this.YEAR_CREATED_FALSE = text;
		});

		this.indicatorFilter.pageControl.limit = 100000;
		this.indicatorFilter.pageControl.page = 0;
		this.indicatorFilter.searchQuery = "";

		if (this.area)
			this.indicatorFilter.areas.push(this.area);

		this.openService.getAreas().then(result => {
			this.areas = result
		});

		this.initDataSource();

		this.labelColumns = this.config.labelIndicatorsColumns;
		this.labelColumnKeys = Object.keys(this.labelColumns);
		this.params.pageControl.order = 'DESC';
		this.params.pageControl.orderField = 'updatedAt';
		this.params.pageControl.limit = 10;

		setTimeout(() => {
			this.initComponent();
		}, 1000);

	}

	ngOnChanges(changes: SimpleChanges): void {
		const {area} = changes;

		if (area?.currentValue !== area?.previousValue) {
			this.indicatorFilter.areas = [area.currentValue];
			this.initComponent();
		}
	}

	initDataSource(): void {
		this.service.getDataSources().then(result => {
			this.dataSources = result['object'];
		});
	}

	initComponent(): void {
		this.loading = true;

		this.initDataSource();

		if (this.cityProfile) {

			let formatAdjustment = {};
			this.service.getCityProfileIndicatorHistory(this.cityId, this.indicatorFilter).then(result => {

				if (result && result.success) {
					formatAdjustment = {
						profile: result['object']['profile'] ?? [],
						indicators: [],
						history: JSON.parse(JSON.stringify(result['object']['profileHistory']['profiles']).split('"profile":').join('"values":'))
					};
				}

				var latinezedSearch = this.sanitizeChar.convert(this.indicatorFilter.searchQuery.toLocaleLowerCase());
				var profiles = latinezedSearch.length == 0 ? this.config.getCityInfoProfile() : this.config.getCityInfoProfile().filter(profile => this.sanitizeChar.convert(profile.title.toLocaleLowerCase()).indexOf(latinezedSearch) > -1);

				profiles.sort((a, b) => {
					var a2 = this.sanitizeChar.convert(a.title.toLowerCase());
					var b2 = this.sanitizeChar.convert(b.title.toLowerCase());

					return a2 < b2 ? -1 : a2 > b2 ? 1 : 0;
				});

				for (let profile of profiles) {
					var tempUnity = null;

					if (profile.labelKey) {
						this.internationalizationService.translate.get(profile.labelKey).subscribe((text: string) => {
							tempUnity = text;
						});
					}

					let tempProfile = {
						id: profile.slug,
						name: profile.title,
						unity: (profile && profile.label) ? profile.label.toString().split("/").join("/ ") : "",
						validation: profile.validation
					}

					if (tempUnity)
						tempProfile.unity = tempUnity;

					formatAdjustment['indicators'].push(tempProfile);
				}

				this.indicators = formatAdjustment as CityIndicatorHistoryHelper;
				this.loading = false;
			});
		} else {

			if (!this._hasDiagnosisFilter()) {
				this.indicatorFilter.purposes.push('DIAGNOSIS');
			}

			this.service.getIndicatorHistory(this.cityId, this.indicatorFilter).then(result => {
				if (result['success']) {
					this.indicators = result.object;
					this.loading = false;
				} else {
					this.snackBar.open(this.UNEXPECTED_ERROR, null, {duration: 3000});
				}
			});
		}
	}

	clearFilter(): void {
		this.indicatorFilter.areas = [];
		this.indicatorFilter.purposes = [];
		this.indicatorFilter.influencesScore = null;
		this.indicatorFilter.searchQuery = null;
		this.initComponent();
	}

	openYear(year: string, dataCity: any): void {

		if (!this.canEdit) return;

		let titleValue;
		this.internationalizationService.translate.get("painel-dashboard/add-year-indicators").subscribe((text: string) => {
			titleValue = year == "new" ? text : year;
		});

		let fieldHelper = new IndicatorFieldHelper("YEAR");
		fieldHelper.value = (year == "new") ? "" : year;

		let fieldHelperObs = new IndicatorFieldHelper("OBSERVATION");
		fieldHelperObs.value = (dataCity && dataCity.observation) ? dataCity.observation : "";

		this._dialogRef = this.dialog.open(IndicatorsSingleDataModalComponent, {
			maxWidth: '700px',
			width: '700px',
			data: new IndicatorFormHelper(titleValue, [fieldHelper, fieldHelperObs])
		});


		this._dialogRef.componentInstance.onSubmitEvent.subscribe((data) => {
			//FORMAT DATA
			let postData = {
				year: data.fields[0].value,
				observation: data.fields[1].value
			};

			if (this.cityProfile) {
				this.service.saveCityProfileIndicatorYear(this.cityId, postData).then(result => {

					if (result['success']) {
						this.snackBar.open(this.YEAR_CREATED_SUCCESS, null, {duration: 3000});
						this._dialogRef.close();
						this.initComponent();
					} else {
						if (result['message'])
							this.snackBar.open(result['message'].toString(), null, {duration: 3000});
						else
							this.snackBar.open(this.YEAR_CREATED_FALSE, null, {duration: 3000});

						this._dialogRef.componentInstance.loading = false;
					}
				});

			} else {
				this.service.saveIndicatorYear(this.cityId, postData).then(result => {

					if (result['success']) {
						this.snackBar.open(this.YEAR_CREATED_SUCCESS, null, {duration: 3000});
						this._dialogRef.close();
						this.initComponent();
					} else {
						if (result['message'])
							this.snackBar.open(result['message'].toString(), null, {duration: 3000});
						else
							this.snackBar.open(this.YEAR_CREATED_FALSE, null, {duration: 3000});

						this._dialogRef.componentInstance.loading = false;
					}
				});
			}
		});

	}

	openFullYear(year: string, dataCity: any): void {
		let titleValue = year;
		let fields = [];

		let fieldHelperDataSrc = new IndicatorFieldHelper("DATA_SOURCE");
		fieldHelperDataSrc.option = this.dataSources;
		fields.push(fieldHelperDataSrc);

		for (let indicator of this.indicators.indicators) {
			let indicatorResult = dataCity.filter(i => i.paramId === indicator.id);
			let field = indicatorResult[0];
			let fieldHelperVal = new IndicatorFieldHelper("VALUE");
			fieldHelperVal.paramId = indicator.id;
			fieldHelperVal.label = indicator.name;
			fieldHelperVal.value = (field && field.value) ? field.value : null;
			fieldHelperVal.unity = (indicator && indicator.unity) ? indicator.unity.toString().split("/").join("/ ") : "";
			fieldHelperVal.validation = indicator.validation;
			fieldHelperVal.dataSourceName = null;


			if (field) {
				let dataSourceResult = this.dataSources.filter(i => i.id === (field && field.dataSourceId ? field.dataSourceId : ""));
				const dataSourceItem = (dataSourceResult[0]) ? dataSourceResult[0] : null;
				fieldHelperVal.dataSourceName = (dataSourceItem && dataSourceItem.name) ? dataSourceItem.name : this.dataSources[0].name;
			}

			fields.push(fieldHelperVal);
		}

		this._dialogRef = this.dialog.open(IndicatorsMultipleDataModalComponent, {
			maxWidth: '1170px',
			width: '1170px',
			data: new IndicatorFormHelper(titleValue, fields)
		});

		this._dialogRef.componentInstance.onSubmitEvent.subscribe((data) => {
			//FORMAT DATA
			let postData = [];

			for (let paramfield of data.fields) {
				let field = {
					paramId: paramfield.paramId,
					value: paramfield.value,
					//observation: paramfield.observation,
					observation: "",
					dataSourceName: paramfield.dataSourceName
				};

				if (field.value)
					postData.push(field);
			}

			if (this.cityProfile) {

				this.service.saveCityProfileIndicatorFullYear(this.cityId, year, postData).then(result => {

					if (result['success']) {
						this.snackBar.open(this.YEAR_UPDATED_SUCCESS, null, {duration: 3000});

						this._dialogRef.close();
						this.initComponent();
					} else {
						this.snackBar.open(this.YEAR_UPDATED_FALSE + result.message, null, {duration: 3000});
						this._dialogRef.componentInstance.loading = false;
					}
				});

			} else {
				this.service.saveIndicatorFullYear(this.cityId, year, postData).then(result => {

					if (result) {
						if (result['success']) {
							this.snackBar.open(this.YEAR_UPDATED_SUCCESS, null, {duration: 3000});

							this._dialogRef.close();
							this.initComponent();
						} else {
							this.snackBar.open(this.YEAR_UPDATED_FALSE + result.message, null, {duration: 3000});
							this._dialogRef.componentInstance.loading = false;
						}
					} else {
						this.snackBar.open(this.UNEXPECTED_ERROR, null, {duration: 3000});
					}
				});
			}
		});
	}

	openSingle(profile: any, year: string, dataCity: any, item): void {

		if (!this.canEdit) return;

		let titleValue = this.getIndicatorName(item.id) + " - " + year;

		let fieldHelperVal = new IndicatorFieldHelper("VALUE");
		fieldHelperVal.value = (dataCity != null && dataCity.value != null) ? dataCity.value : "";
		fieldHelperVal.unity = (item && item.unity) ? item.unity.toString().split("/").join("/ ") : "";
		fieldHelperVal.validation = (item && item.validation) ? item.validation : "";

		let fieldHelperObs = new IndicatorFieldHelper("OBSERVATION");
		fieldHelperObs.value = (dataCity != null && dataCity.observation != null) ? dataCity.observation : "";

		let fieldHelperDataSrc = new IndicatorFieldHelper("DATA_SOURCE");
		if (dataCity) {
			let dataSourceResult = this.dataSources.filter(i => i.id === (dataCity.dataSourceId ? dataCity.dataSourceId : ""));
			const dataSourceItem = (dataSourceResult[0]) ? dataSourceResult[0] : null;
			fieldHelperDataSrc.value = (dataSourceItem != null && dataSourceItem.name != null) ? dataSourceItem.name : this.dataSources[0].name;
		}
		fieldHelperDataSrc.option = this.dataSources;

		this._dialogRef = this.dialog.open(IndicatorsSingleDataModalComponent, {
			maxWidth: '700px',
			width: '700px',
			data: new IndicatorFormHelper(titleValue, [fieldHelperVal, fieldHelperObs, fieldHelperDataSrc])
		});


		this._dialogRef.componentInstance.onSubmitEvent.subscribe((data) => {
			//FORMAT DATA
			let postData = {
				paramId: item.id,
				value: data.fields[0].value,
				observation: data.fields[1].value,
				dataSourceName: data.fields[2].value
			};

			if (this.cityProfile) {
				this.service.saveProfileSingleIndicatorData(this.cityId, year, postData).then(result => {

					if (result) {
						if (result['success']) {
							this.snackBar.open((dataCity) ? this.INDICATOR_UPDATED_SUCCESS : this.INDICATOR_CREATED_SUCCESS, null, {duration: 3000});

							// dataCity.value = data.fields[0].value;
							// dataCity.observation = data.fields[1].value;
							// dataCity.dataSourceId = data.fields[2].value;

							this._dialogRef.close();
							this.initComponent();
						} else {
							this.snackBar.open((dataCity) ? this.INDICATOR_UPDATED_FALSE + result.message : this.INDICATOR_CREATED_FALSE + result.message, null, {duration: 3000});
							this._dialogRef.componentInstance.loading = false;
						}
					} else {
						this.snackBar.open(this.UNEXPECTED_ERROR, null, {duration: 3000});
					}
				});

			} else {
				this.service.saveSingleIndicatorData(this.cityId, year, postData).then(result => {

					if (result['success']) {
						this.snackBar.open((dataCity) ? this.INDICATOR_UPDATED_SUCCESS : this.INDICATOR_CREATED_SUCCESS, null, {duration: 3000});

						// dataCity.value = data.fields[0].value;
						// dataCity.observation = data.fields[1].value;
						// dataCity.dataSourceId = data.fields[2].value;

						this._dialogRef.close();
						this.initComponent();
					} else {
						this.snackBar.open((dataCity) ? this.INDICATOR_UPDATED_FALSE + result.message : this.INDICATOR_CREATED_FALSE + result.message, null, {duration: 3000});
						this._dialogRef.componentInstance.loading = false;
					}
				});
			}
		});

		this._dialogRef.componentInstance.onDeleteEvent.subscribe((data) => {
			//FORMAT DATA
			let postData = {
				paramId: item.id
			};

			if (this.cityProfile) {
				this.service.deleteProfileSingleIndicatorData(this.cityId, year, postData).then(result => {

					if (result) {
						if (result['success']) {
							this.snackBar.open(this.DATA_DELETED_SUCCESS, null, {duration: 3000});

							this._dialogRef.close();
							this.initComponent();
						} else {
							this.snackBar.open(this.DATA_DELETED_FALSE, null, {duration: 3000});
							this._dialogRef.componentInstance.loading = false;
						}
					} else {
						this.snackBar.open(this.UNEXPECTED_ERROR, null, {duration: 3000});
					}
				});

			} else {
				this.service.deleteSingleIndicatorData(this.cityId, year, postData).then(result => {

					if (result['success']) {
						this.snackBar.open(this.DATA_DELETED_SUCCESS, null, {duration: 3000});

						this._dialogRef.close();
						this.initComponent();
					} else {
						this.snackBar.open(this.DATA_DELETED_FALSE, null, {duration: 3000});
						this._dialogRef.componentInstance.loading = false;
					}
				});
			}
		});

	}

	openDisplayed(dataCity: any, item): void {

		if (!this.canEdit) return;

		let titleValue = this.getIndicatorName(item.id);

		let fieldHelperVal = new IndicatorFieldHelper("VALUE");
		fieldHelperVal.value = "";
		fieldHelperVal.unity = (item && item.unity) ? item.unity.toString().split("/").join("/ ") : "";
		fieldHelperVal.validation = (item && item.validation) ? item.validation : "";

		let fieldHelperYear = new IndicatorFieldHelper("YEAR");
		fieldHelperYear.value = "";

		let fieldHelperObs = new IndicatorFieldHelper("OBSERVATION");
		fieldHelperObs.value = "";

		let fieldHelperDataSrc = new IndicatorFieldHelper("DATA_SOURCE");
		if (dataCity) {
			let dataSourceResult = this.dataSources.filter(i => i.id === (dataCity.dataSourceId ? dataCity.dataSourceId : ""));
			const dataSourceItem = (dataSourceResult[0]) ? dataSourceResult[0] : null;
			fieldHelperDataSrc.value = (dataSourceItem && dataSourceItem.name) ? dataSourceItem.name : this.dataSources[0].name;
		}
		fieldHelperDataSrc.option = this.dataSources;

		this._dialogRef = this.dialog.open(IndicatorsSingleDataModalComponent, {
			maxWidth: '700px',
			width: '700px',
			data: new IndicatorFormHelper(titleValue, [fieldHelperVal, fieldHelperYear, fieldHelperObs, fieldHelperDataSrc])
		});

		this._dialogRef.componentInstance.onSubmitEvent.subscribe((data) => {
			//FORMAT DATA
			let postData = {
				paramId: item.id,
				value: data.fields[0].value,
				observation: data.fields[2].value,
				dataSourceName: data.fields[3].value
			};

			if (this.cityProfile) {
				this.service.saveProfileSingleIndicatorData(this.cityId, data.fields[1].value, postData).then(result => {

					if (result?.success) {
						this.snackBar.open((dataCity) ? this.INDICATOR_UPDATED_SUCCESS : this.INDICATOR_CREATED_SUCCESS, null, {duration: 3000});

						this._dialogRef.close();
						this.initComponent();
					} else {
						this.snackBar.open((dataCity) ? this.INDICATOR_UPDATED_FALSE + result.message : this.INDICATOR_CREATED_FALSE + result.message, null, {duration: 3000});
						this._dialogRef.componentInstance.loading = false;
					}
				});
			} else {
				this.service.saveSingleIndicatorData(this.cityId, data.fields[1].value, postData).then(result => {

					if (result?.success) {
						this.snackBar.open((dataCity) ? this.INDICATOR_UPDATED_SUCCESS : this.INDICATOR_CREATED_SUCCESS, null, {duration: 3000});

						this._dialogRef.close();
						this.initComponent();
					} else {
						this.snackBar.open((dataCity) ? this.INDICATOR_UPDATED_FALSE + result.message : this.INDICATOR_CREATED_FALSE + result.message, null, {duration: 3000});
						this._dialogRef.componentInstance.loading = false;
					}
				});
			}
		});
	}

	getScoreById(id: string): number {
		if (this.cityProfile) {
			return this.indicators.profile[id] ? this.indicators.profile[id] : 0;
		} else {
			const score: CityIndicatorScore[] = this.indicators.indicatorScores.filter(item => (item.indicatorId === id));
			return (score.length) ? score[0].score : 0;
		}
	}

	getIndicatorName(id: string): string {
		const indicator: IndicatorHelper[] = this.indicators.indicators.filter(item => (item.id === id));
		return (indicator[0].name) ? indicator[0].name : "UNKNOWN";
	}

	getItemProfile(id: string, data: CityDataInfo[]): CityDataInfo {
		if (!data)
			return null;

		const items = data.filter(proof => proof.paramId === id);
		return (items[0]) ? items[0] : null;
	}

	getItemProfileValue(id: string, data: CityDataInfo[]): string {
		const items = data.filter(proof => proof.paramId === id);
		return (items[0]) ? items[0].value.toString() : '-';
	}

	getDataSourceName(id: string, data: CityDataInfo[]): string {
		const items = data.filter(proof => proof.paramId === id);
		const paramId = (items[0]) ? items[0].dataSourceId : null;
		const dataSources = this.dataSources.filter(item => item.id.indexOf(paramId) > -1);
		return (dataSources.length) ? dataSources[0].name : null;
	}

	private _hasDiagnosisFilter(): boolean {
		return this.indicatorFilter.purposes.includes('DIAGNOSIS');
	}
}

export class CityIndicatorHistoryHelper {
	history: CityIndicatorValueYear[] = [];
	indicatorScores: CityIndicatorScore[] = [];
	indicators: IndicatorHelper[] = [];
	profile: string[] = [];
}

export class CityIndicatorValueYear {
	values: CityDataInfo[] = [];
	year: number;
	paramId: string;
}

export class IndicatorHelper {
	areas: string[] = [];
	id: string;
	name: string;
	unity: string;
	validation: string;
}

export class IndicatorFormHelper {
	title: string;
	fields: IndicatorFieldHelper[] = [];

	constructor(title: string, fields?: IndicatorFieldHelper[]) {
		this.title = title;
		this.fields = fields;
	}
}

export class IndicatorFieldHelper {
	id: string;
	label: string;
	value: string;
	unity: string;
	validation: string;
	option: IndicatorFieldOptionItem[] = [];
	dataSourceId: string;
	dataSourceName: string;
	paramId: string;

	constructor(id: string, label?: string, value?: string, option?: IndicatorFieldOptionItem[], dataSourceId?: string, dataSourceName?: string, paramId?: string) {
		this.id = id;
		this.label = label;
		this.value = value;
		this.option = option;
		this.dataSourceId = dataSourceId;
		this.dataSourceName = dataSourceName;
		this.paramId = paramId;
	}
}

export class IndicatorFieldOptionItem {
	id: string;
	name: string;

	constructor(id: string, name: string) {
		this.id = id;
		this.name = name;
	}
}
